import { render } from "./layout.vue?vue&type=template&id=dc9fe3d2&scoped=true&ts=true"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"

import "./layout.vue?vue&type=style&index=0&id=dc9fe3d2&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc9fe3d2"]])

export default __exports__